import { Directive, ElementRef, inject } from "@angular/core";

/** Opens a native select listbox on Enter (browsers default to Space / arrow keys). */
@Directive({
    standalone: true,
    selector: "select[s25-ng-select-enter-opens]",
    host: {
        "(keydown)": "onKeydown($event)",
    },
})
export class S25SelectEnterOpensDirective {
    private readonly elementRef = inject<ElementRef<HTMLSelectElement>>(ElementRef);

    onKeydown(event: KeyboardEvent): void {
        if (event.key !== "Enter") return;
        event.preventDefault();
        const select = this.elementRef.nativeElement;
        if (typeof select.showPicker === "function") {
            try {
                select.showPicker();
                return;
            } catch {
                // showPicker can throw when unsupported or not user-initiated.
            }
        }
        select.click();
    }
}
